import request from "@/http/axios/axios";

// 退出登录
export const fetchStudentLogout = async function (data?: any): Promise<any> {
  return await request.post(`/api/student/auth/logout`, data);
};
// 学生登录
export const fetchStudentLogin = async function (data?: any): Promise<any> {
  return await request.post(`/api/student/auth/login`, data, { skipAuth: true });
};
// 刷新Token
export const fetchStudentRefreshToken = async function (data?: any): Promise<any> {
  return await request.post(`/api/student/auth/refreshToken`, data, { skipAuth: true });
};
// 获取当前学生账号详情（学生端）
export const fetchStudentInfo = async function (data?: any): Promise<any> {
  return await request.get(`/api/student/auth/info`, data);
};
// 学生修改密码（学生端）
export const fetchStudentUpdatePassword = async function (data?: any): Promise<any> {
  return await request.post(`/api/student/auth/updatePassword`, data);
};
// 学生修改个人信息（学生端）
export const fetchStudentUpdateStudent = async function (data?: any): Promise<any> {
  return await request.post(`/api/student/auth/updateStudent`, data);
};
